import { useState, useEffect, useRef } from 'react';
import type { ReactNode } from 'react';

export function LazySection({ children, className, minHeight = "50vh" }: { children: ReactNode, className?: string, minHeight?: string }) {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, { rootMargin: "300px" });
    
    if (domRef.current) {
      observer.observe(domRef.current);
    }
    
    return () => observer.disconnect();
  }, []);

  return (
    <div 
      ref={domRef} 
      className={className} 
      style={{ minHeight: isVisible ? 'auto' : minHeight, opacity: isVisible ? 1 : 0, transition: 'opacity 0.8s ease-in-out' }}
    >
      {isVisible ? children : null}
    </div>
  );
}
